import styled from '@emotion/styled';
import { useRouter } from 'next/router';
import Link from 'next/link';
import { Spacings, mediaQuery } from '@styles/index';
import { Typography } from 'aquilla/core/atoms/Typography';
import { useIsMobile } from '@stores/AppCommonData';
import NotesTrackCard from '../WithoutAddressComponents/NotesTrackCard';

const StyHeader = styled(Typography)``;

const NotesCardWrapper = styled.div`
  display: grid;
  grid-column: span 18;
  grid-row-gap: ${Spacings.SPACING_8B};
  margin-bottom: ${Spacings.SPACING_9B};
  margin-top: ${Spacings.SPACING_8B};
  ${mediaQuery.uptoMobile} {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: ${Spacings.SPACING_6B};
    margin-top: ${Spacings.SPACING_0B};
  }
`;

const StyLink = styled.div`
  display: grid;
  padding: 24px;
  text-decoration: none;
  border-radius: 8px;
  background: var(--color-base-1);
  box-shadow: 0px 16px 32px 0px rgba(60, 72, 82, 0.04);
  ${mediaQuery.uptoMobile} {
    padding: ${Spacings.SPACING_4B};
  }
`;

const deliveryStates = {
  ADDRESS_PENDING: 1,
  DISPATCH_PENDING: 2,
  DISPATCHED: 3,
  DELIVERED: 4,
  MULTIPLE_DELIVERIES: -1
};

const BrowseNotesTrackCardWrapper = ({ data }) => {
  const router = useRouter();
  const {
    query: { goalUID }
  } = router;
  const { ctaLabel, subTitle, title, purchasedItemsDeliveryData, status } =
    data[0];
  const isMobile = useIsMobile();

  const { storeBundleUid = '' } = purchasedItemsDeliveryData
    ? purchasedItemsDeliveryData[0]
    : {};

  const redirectLink = () => {
    if (purchasedItemsDeliveryData) {
      if (purchasedItemsDeliveryData?.length > 1) {
        return isMobile
          ? `/store/notes/-/${storeBundleUid}?redirect=true`
          : `/store/notes/${goalUID}/tracking-flow`;
      }
      if (purchasedItemsDeliveryData?.length === 1) {
        if (status === deliveryStates.ADDRESS_PENDING) {
          return `/goal/-/${goalUID}/setup-address`;
        }
      }
    }
    return isMobile
      ? `/store/notes/-/${storeBundleUid}?redirect=true`
      : `/store/notes/${goalUID}/tracking-flow`;
  };

  const redirectPage = () => {
    const path = redirectLink();
    router.push(path, path);
  };

  return (
    <NotesCardWrapper>
      <StyHeader variant="h4">Physical notes</StyHeader>
      <StyLink onClick={redirectPage}>
        <NotesTrackCard
          title={title}
          subTitle={subTitle}
          iconWidth={48}
          iconHeight={48}
          buttonText={ctaLabel}
          gap="16px"
          onClick={() => {}}
          buttonType="primary"
        />
      </StyLink>
    </NotesCardWrapper>
  );
};

export default BrowseNotesTrackCardWrapper;
